<template>
  <div class="common-table">
    <div class="overBanner">
      <img :src="commonbg" width='100%' alt="">
    </div>
    <div class="union-summary">
      <div class="summaryItem">
        <div class="union-item-title">
          <div class='title-item' @click="checkItem(1)">联盟简介</div>
          <div class='title-item' @click="checkItem(2)">联盟章程</div>
        </div>
        <div class="hr-type">
          <el-divider></el-divider>
        </div>
        <div class="union-item" v-show="isChapter">
          <union-chapter></union-chapter>
        </div>
        <div class="union-item" v-show="!isChapter">
          <union-summary></union-summary>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import unionChapter from './unionChapter';
import unionSummary from './unionSummary';
export default {
  data() {
    return {
      isChapter: false,
      routerData: ''
    };
  },
  components: {
    unionChapter,
    unionSummary
  },
  created() {
    this.getRouterParams();
  },
  computed: {
    commonbg() {
      return this.$store.state.commonbg;
    }
  },
  mounted() {
    this.checkItem(this.routerData);
  },
  methods: {
    getRouterParams() {
      if (this.$route.params.summaryType) {
        this.routerData = this.$route.params.summaryType;
      } else {
        this.routerData = 1;
      }
    },
    checkItem(checkNo) {
      $('.title-item')
        .not(checkNo - 1)
        .removeClass('activeStyle');
      $('.title-item')
        .eq(checkNo - 1)
        .addClass('activeStyle');
      if (checkNo === 1) {
        this.isChapter = false;
      } else {
        this.isChapter = true;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.overBanner {
  width: 100%;
  margin-bottom: 20px;
}

.union-summary {
  width: 100%;

  .summaryItem {
    width: 70%;
    margin: 0 auto;
    min-height: 600px;

    .union-item-title {
      width: 100%;
      height: 50px;
      line-height: 50px;

      .title-item {
        float: left;
        margin-left: 20px;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        padding: 5px 10px;
      }

      .title-item:hover {
        background-color: #DCDCDC;
        color: #8a8a8a;
        border-color: #DCDCDC;
      }
    }

    .hr-type {
      height: 10px;
      width: 100%;
      margin: -19px 0px 15px;
    }

    .union-item {
      width: 100%;
    }
  }
}

.activeStyle {
  background-color: #409EFF;
  color: #fff;
  border: 1px solid #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/overview/overview.vue